// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\Api\PSixVesselParticular\ApiPSixVesselParticular.cs
import S, { DataSignal } from 's-js';
import SArray, { SDataArray } from 's-array';
import TZDate from 'lib/TZDate';
import { jsonableObservable } from 'lib/jsonableObservable';
import { PSixVesselResult, PSixVesselResultData, PSixVesselResultOptions } from 'data/models/PSixVesselResult';

// PSixVesselParticularData is the class that PSixVesselParticular serializes to/from
export interface PSixVesselParticularData {
    Id : number;
	
    CountryLookupId : string | null;
    IdentificationTypeLookupId : number;
    VesselResult : PSixVesselResultData | null;
	
    CountryLookupName : string | null;
    CreatedOnUtc : /* ISO8601 */ string;
    Guid : /* GUID */ string;
    Identification : string | null;
    IdentificationTypeLookupName : string | null;
    ServiceType : string | null;
    StatusLookupName : string | null;
    VesselName : string | null;
}

// PSixVesselParticularOptions is the class which may be passed to the PSixVesselParticular constructor to define optional initial data values
export interface PSixVesselParticularOptions {
    Id : number;
	
    CountryLookupId? : string | null;
    IdentificationTypeLookupId? : number;
    VesselResult? : PSixVesselResultOptions | null;
	
    CountryLookupName? : string | null;
    CreatedOnUtc? : /* ISO8601 */ string;
    Guid? : /* GUID */ string;
    Identification? : string | null;
    IdentificationTypeLookupName? : string | null;
    ServiceType? : string | null;
    StatusLookupName? : string | null;
    VesselName? : string | null;
}

export class PSixVesselParticular {
    public Id : DataSignal<number>;
	
    public CountryLookupId : DataSignal<string | null>;
    public IdentificationTypeLookupId : DataSignal<number>;
    public VesselResult : DataSignal<PSixVesselResult | null>;
	
    public CountryLookupName : DataSignal<string | null>;
    public CreatedOnUtc : DataSignal<TZDate>;
    public Guid : DataSignal<string>;
    public Identification : DataSignal<string | null>;
    public IdentificationTypeLookupName : DataSignal<string | null>;
    public ServiceType : DataSignal<string | null>;
    public StatusLookupName : DataSignal<string | null>;
    public VesselName : DataSignal<string | null>;

    constructor();
    constructor(data : PSixVesselParticularOptions);
    constructor(data: PSixVesselParticularOptions | null = null) {
        this.Id = jsonableObservable(S.value<number>(data && data.Id !== undefined ? data.Id : 0));
	    
        this.CountryLookupId = jsonableObservable(S.value<string | null>(data && data.CountryLookupId !== undefined ? data.CountryLookupId : null));
        this.IdentificationTypeLookupId = jsonableObservable(S.value<number>(data && data.IdentificationTypeLookupId !== undefined ? data.IdentificationTypeLookupId : 0));
        this.VesselResult = S.value<PSixVesselResult | null>(null);
	    
        this.CountryLookupName = jsonableObservable(S.value<string | null>(data && data.CountryLookupName !== undefined ? data.CountryLookupName : null));
        this.CreatedOnUtc = jsonableObservable(S.value<TZDate>(data && data.CreatedOnUtc !== undefined ? new TZDate(data.CreatedOnUtc) : new TZDate(0), TZDate.eq));
        this.Guid = jsonableObservable(S.value<string>(data && data.Guid !== undefined ? data.Guid : '00000000-0000-0000-0000-000000000000'));
        this.Identification = jsonableObservable(S.value<string | null>(data && data.Identification !== undefined ? data.Identification : null));
        this.IdentificationTypeLookupName = jsonableObservable(S.value<string | null>(data && data.IdentificationTypeLookupName !== undefined ? data.IdentificationTypeLookupName : null));
        this.ServiceType = jsonableObservable(S.value<string | null>(data && data.ServiceType !== undefined ? data.ServiceType : null));
        this.StatusLookupName = jsonableObservable(S.value<string | null>(data && data.StatusLookupName !== undefined ? data.StatusLookupName : null));
        this.VesselName = jsonableObservable(S.value<string | null>(data && data.VesselName !== undefined ? data.VesselName : null));
    }

    static key(obj : PSixVesselParticular) {
        return obj.Id();
    }
    
    static dataKey(obj : PSixVesselParticularOptions) {
        return obj.Id;
    }

    static update(obj : PSixVesselParticular, data : PSixVesselParticularOptions) {
        S.freeze(() => {
            if (data.Id !== undefined) obj.Id(data.Id);
	        
            if (data.CountryLookupId !== undefined) obj.CountryLookupId(data.CountryLookupId);
            if (data.IdentificationTypeLookupId !== undefined) obj.IdentificationTypeLookupId(data.IdentificationTypeLookupId);
	        
            if (data.CountryLookupName !== undefined) obj.CountryLookupName(data.CountryLookupName);
            if (data.CreatedOnUtc !== undefined) obj.CreatedOnUtc(new TZDate(data.CreatedOnUtc));
            if (data.Guid !== undefined) obj.Guid(data.Guid);
            if (data.Identification !== undefined) obj.Identification(data.Identification);
            if (data.IdentificationTypeLookupName !== undefined) obj.IdentificationTypeLookupName(data.IdentificationTypeLookupName);
            if (data.ServiceType !== undefined) obj.ServiceType(data.ServiceType);
            if (data.StatusLookupName !== undefined) obj.StatusLookupName(data.StatusLookupName);
            if (data.VesselName !== undefined) obj.VesselName(data.VesselName);
        });
    }
}



// WEBPACK FOOTER //
// ./server/models/PSixVesselParticular.ts